module.exports = __webpack_public_path__ + "static/media/lysithea-vonordelia-lose.92a41c0e.png";